import { Trans } from '@lingui/react'
import { node, number, objectOf, shape, string } from 'prop-types'
import { cloneElement } from 'react'

import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import { getLocalisedDay, getLocalisedHour } from './helpers'

const HotlineHours = props => {
  const {
    itemWrapper,
    separator,
    publicRuntimeConfig: {
      publicConfig: { locale },
    },
    shopConfig: {
      contact: { officeHours },
    },
  } = props

  return !officeHours
    ? null
    : Object.values(officeHours).map(({ days, hours }, idx) => (
        <>
          {idx === 0 ? null : separator}
          {cloneElement(
            itemWrapper,
            {},
            days.start === days.end ? (
              <Trans
                id="hotlineHours.singleDay"
                values={{
                  day: getLocalisedDay(locale, days.start),
                  timeStart: getLocalisedHour(locale, hours.start),
                  timeEnd: getLocalisedHour(locale, hours.end),
                }}
              />
            ) : (
              <Trans
                id="hotlineHours.dayRange"
                values={{
                  dayStart: getLocalisedDay(locale, days.start),
                  dayEnd: getLocalisedDay(locale, days.end),
                  timeStart: getLocalisedHour(locale, hours.start),
                  timeEnd: getLocalisedHour(locale, hours.end),
                }}
              />
            )
          )}
        </>
      ))
}

HotlineHours.propTypes = {
  itemWrapper: node,
  separator: node,
  publicRuntimeConfig: shape({
    publicConfig: shape({
      locale: string.isRequired,
    }).isRequired,
  }).isRequired,
  shopConfig: shape({
    contact: shape({
      officeHours: objectOf(
        shape({
          days: shape({
            start: number.isRequired,
            end: number.isRequired,
          }).isRequired,
          hours: shape({
            start: number.isRequired,
            end: number.isRequired,
          }).isRequired,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
}

HotlineHours.defaultProps = {
  itemWrapper: <></>, // eslint-disable-line react/jsx-no-useless-fragment
  separator: ', ',
}

export default withShopAndRuntimeConfig(HotlineHours)
